import { EVENT_ONBOARDING_DIALOG_CLOSED, EVENT_OPEN_ONBOARDING_DIALOG } from "../constants";

/**
 * Singleton to track onboarding dialog open status via window events.
 * Avoids relying on React state which can miss events when hook instances mount late.
 * Follows the same pattern as GameIframeStateTracker and DailyRewardModalTracker.
 */
export class OnboardingDialogTracker {
  private static instance: OnboardingDialogTracker | null = null;
  private isDialogOpen = false;
  private isDialogPending = false;

  private readonly handleOpen = () => {
    this.isDialogPending = false;
    this.isDialogOpen = true;
  };

  private readonly handleClose = () => {
    this.isDialogPending = false;
    this.isDialogOpen = false;
  };

  private constructor() {
    window.addEventListener(EVENT_OPEN_ONBOARDING_DIALOG, this.handleOpen);
    window.addEventListener(EVENT_ONBOARDING_DIALOG_CLOSED, this.handleClose);
  }

  static getInstance(): OnboardingDialogTracker {
    if (!OnboardingDialogTracker.instance) {
      OnboardingDialogTracker.instance = new OnboardingDialogTracker();
    }
    return OnboardingDialogTracker.instance;
  }

  /**
   * Call this synchronously before triggering the dialog via async event queue.
   * Ensures areConditionsMet sees the intent before the event dispatches.
   */
  setPending(): void {
    this.isDialogPending = true;
  }

  isOpen(): boolean {
    return this.isDialogOpen;
  }

  isPendingOrOpen(): boolean {
    return this.isDialogPending || this.isDialogOpen;
  }

  cleanup(): void {
    window.removeEventListener(EVENT_OPEN_ONBOARDING_DIALOG, this.handleOpen);
    window.removeEventListener(EVENT_ONBOARDING_DIALOG_CLOSED, this.handleClose);
  }
}

// Eagerly initialize so event listeners are registered before any React render
OnboardingDialogTracker.getInstance();
